export default "__VITE_ASSET__CK03GnU7__"